import { render } from "./CarInspectionConfirm.vue?vue&type=template&id=281189a1"
import script from "./CarInspectionConfirm.vue?vue&type=script&lang=js"
export * from "./CarInspectionConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__